import { ApplicationState } from '../index';
import { User } from '../../types'

export const currentUserSelector = (state: ApplicationState): User | null =>
  state.currentUser
